module.exports = __webpack_public_path__ + "img/marker-idle.66b0db57.svg";